/**
 * creates an enum, index start the same as in db from one;
 * @param {Array} list the list of elements ["A", "B", "C", ..]
 */
export function createEnum(list: string[]): { [key: string]: number } {
    const enumObj = {};

    for (let i = 0; i < list.length; i += 1) {
        if (list[i] !== undefined && list[i] !== null) {
            enumObj[list[i]] = i + 1;
        }
    }

    if (Object.freeze) {
        Object.freeze(enumObj);
    }

    return enumObj;
}
